import { render, staticRenderFns } from "./ReportAdmin.vue?vue&type=template&id=09132b90&"
import script from "@/views/Authed/ReportAdmin/ReportAdmin.js?vue&type=script&lang=js&"
export * from "@/views/Authed/ReportAdmin/ReportAdmin.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports